var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-bars",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "ng-attr-x": "{{config.x1}}",
    y: 30,
    "ng-attr-width": "{{config.width}}",
    height: 40,
    fill: "#5fabde",
    x: 16.5,
    width: 7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    values: "1;0.2;1",
    keyTimes: "0;0.5;1",
    dur: 1,
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-0.6s",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "ng-attr-x": "{{config.x2}}",
    y: 30,
    "ng-attr-width": "{{config.width}}",
    height: 40,
    fill: "#5FABDE",
    x: 36.5,
    width: 7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    values: "1;0.2;1",
    keyTimes: "0;0.5;1",
    dur: 1,
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-0.4s",
    repeatCount: "indefinite"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "ng-attr-x": "{{config.x3}}",
    y: 30,
    "ng-attr-width": "{{config.width}}",
    height: 40,
    fill: "#196FAA",
    x: 56.5,
    width: 7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    values: "1;0.2;1",
    keyTimes: "0;0.5;1",
    dur: 1,
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-0.2s",
    repeatCount: "indefinite"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    "ng-attr-x": "{{config.x4}}",
    y: 30,
    "ng-attr-width": "{{config.width}}",
    height: 40,
    fill: "#196faa",
    x: 76.5,
    width: 7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    values: "1;0.2;1",
    keyTimes: "0;0.5;1",
    dur: 1,
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "0s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.c27cac7389d89cdd5d5b99e58c3d58e3.svg";
export { ForwardRef as ReactComponent };